<template>
  <div class="alert-danger" v-html="errorMessage[0]"></div>
</template>

<script>
export default {
  name: 'error-message',
  props: ['errorMessage']
}
</script>
